












import { computed, defineComponent, PropType } from '@vue/composition-api';
import ScrollNotice from '@/components/common/scroll-notice.vue';

type Theme = 'red' | 'orange';

export default defineComponent({
  name: 'ThemeNotice',
  components: { ScrollNotice },
  props: {
    text: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    theme: {
      type: String as PropType<Theme>,
      default: 'red',
    },
    isScroll: {
      type: Boolean,
      default: true,
    },
  },
  setup(prop) {
    const style = computed(() => {
      if (prop.theme === 'red') {
        return {
          background: '#fff1f1',
          color: '#ff6666',
        };
      }
      return {
        background: '#fffaec',
        color: '#FA9D3B',
      };
    });
    return { style };
  },
});
